import React from 'react'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
    
    
  return (
    <div style={{backgroundColor:('red')}}>
        <nav className={`navbar navbar-expand-lg navbar-${props.theme} bg-${props.theme}` } >
  <div className="container-fluid">
    <Link className="navbar-brand" to='/'>Navbar</Link>
    <form className="d-flex" role="search">
      <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
      <button className="btn btn-outline-success" type="submit">Search</button>
    </form>
    <div className='d-flex'>
        <div className='bg-primary rounded mx-2' onClick={()=>{props.tgl('primary')}} style={{height:'30px',width:'30px'}}></div>
        <div className='bg-success rounded mx-2' onClick={()=>{props.tgl('success')}} style={{height:'30px',width:'30px'}}></div>
        <div className='bg-danger rounded mx-2' onClick={()=>{props.tgl('danger')}} style={{height:'30px',width:'30px'}}></div>
        <div className='bg-dark rounded mx-2' onClick={()=>{props.tgl('dark')}} style={{height:'30px',width:'30px'}}></div>
    </div>
    <div className={`form-check form-switch text-${props.theme==='light'?'dark':'light'}`}>
      <input className='form-check-input' type='checkbox' id='1inp' onClick={props.toggle}/>
      <label className='form-check-label' htmlFor='flexSwitchCheckDefault' id='2inp'>Enable DarkMode </label>
      <Link className="navbar-brand" to='/about'>About</Link>
      
    </div>
    <div className={`form-check form-switch text-${props.theme==='light'?'dark':'light'}`}>
      <input className='form-check-input' type='checkbox' id='1inp' onClick={()=>{props.nw(null)}}/>
      <label className='form-check-label' htmlFor='flexSwitchCheckDefault' id='3inp'>Enable OrangeMode </label>
      
    </div>
  </div>
</nav>
    </div>
  )
}
